import { render, staticRenderFns } from "./TablaComplejidadesProyecto.vue?vue&type=template&id=46b41908"
import script from "./TablaComplejidadesProyecto.vue?vue&type=script&lang=js"
export * from "./TablaComplejidadesProyecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports